<template>
  <div class="pa-6">
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card outlined class="pa-4">
          <div class="text-center mb-4">
            <div class="font-weight-bold text-uppercase">
              BÁO CÁO THEO GIÁO VIÊN
            </div>
            <!-- <div class="font-weight-bold text-uppercase">
                {{ semesterTitle }}
              </div> -->
          </div>

          <div class="d-flex justify-center my-4">
            <v-btn :loading="loadingTeacher" color="primary" @click="exportTeacherReport">
              Xuất file
            </v-btn>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="pa-4">
          <div class="text-center mb-4">
            <div class="font-weight-bold text-uppercase">
              BÁO CÁO THEO LỚP
            </div>
            <!-- <div class="font-weight-bold text-uppercase">
                {{ semesterTitle }}
              </div> -->
          </div>

          <div class="d-flex justify-center my-4">
            <v-btn :loading="loadingSchool" color="primary" @click="exportSchoolReport">
              Xuất file
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import * as XLSX from 'xlsx'
// import { saveAs } from 'file-saver'
import { mapActions } from 'vuex'

export default {
  props: {
    selectedSemester: { type: Object, required: true }
  },
  data() {
    return {
      loadingTeacher: false,
      loadingSchool: false
    }
  },
  computed: {
    semesterTitle() {
      var s = this.selectedSemester
      if (!s) return ''
      var semTitle = ''
      if (s.title) semTitle = String(s.title).toUpperCase()
      var yearName = ''
      if (s.schoolYear) {
        if (typeof s.schoolYear === 'object' && s.schoolYear.name) yearName = String(s.schoolYear.name).toUpperCase()
        else if (typeof s.schoolYear === 'string') yearName = String(s.schoolYear).toUpperCase()
      }
      if (yearName === '') return semTitle
      return semTitle + ' - ' + yearName
    }
  },
  methods: {
    ...mapActions('ClassMarkReport', ['fetchMarks', 'generateTeacherWorkbookAndSave', 'generateSchoolWorkbookAndSave']),

    async exportTeacherReport() {
      this.loadingTeacher = true
      try {
        const marks = await this.fetchMarks({ semester: this.selectedSemester.id, limit: -1, isReport: true })
        await this.generateTeacherWorkbookAndSave({ marks, selectedSemester: this.selectedSemester })
      } finally {
        this.loadingTeacher = false
      }
    },

    async exportSchoolReport() {
      this.loadingSchool = true
      try {
        const marks = await this.fetchMarks({ semester: this.selectedSemester.id, limit: -1, isReport: true })
        await this.generateSchoolWorkbookAndSave({ marks, selectedSemester: this.selectedSemester })
      } finally {
        this.loadingSchool = false
      }
    }
  }
}
</script>

<style scoped>
.font-weight-bold {
  font-weight: 700;
}
.text-uppercase {
  text-transform: uppercase;
}
</style>
